// extracted by mini-css-extract-plugin
export default {"chatHead":"chatHead_chatHead__OHIGX","btns":"chatHead_btns__jrwdD","chatHead__user":"chatHead_chatHead__user__L6JJV","show":"chatHead_show__5FxEC"};